import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import {uniqueUuid} from "@vesta/unique/unique";
import {z as zod} from "zod";

const cacheEntryValidator = zod.object({key: zod.unknown(), value: zod.unknown()});

export const analyticsCacheSnapshotValidator = zod.object({
    name: zod.string(),
    size: zod.number(),
    maximumSize: zod.number(),
    expireAfterWrite: zod.unknown(),
    entries: zod.array(cacheEntryValidator),
});

export type AnalyticsCacheSnapshot = zod.infer<typeof analyticsCacheSnapshotValidator>;
export const ANALYTICS_CACHE_QUERY_KEY = uniqueUuid`a7d4e6c3-4a64-4f48-a9ea-0490d35595c2`;

export async function fetchAnalyticsCaches({
    accessToken,
    intellsysBaseUrl,
}: {
    accessToken: string;
    intellsysBaseUrl: string;
}): Promise<Array<AnalyticsCacheSnapshot>> {
    const result = await robustJsonResultClientFetch(
        `${intellsysBaseUrl}/sub-system/erato/admin/analytics/cache`,
        {headers: {Authorization: `Bearer ${accessToken}`}},
        zod.array(analyticsCacheSnapshotValidator),
    );
    if (result.success !== true) {
        throw result.error;
    }
    return result.data;
}
